module.exports = __webpack_public_path__ + "img/CloudsAndSnow.1babe76e.png";